/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";

export default function ElementToCatchFocusThatHappensAfterUserAcceptCookies() {
  return <a href="#" id="AccessibilityLink" tabIndex="-1" />;
}
